import React, { useEffect, useRef } from 'react';
import { OnboardingV2State } from '../../../store/onboardingV2/types.ts';
import { getAllSteps, getCurrentStep, OnboardingStep } from '../../../utils/onboardingV2/conversationalOnboardingSteps.ts';
import OnboardingProgress from './OnboardingProgress.tsx';
import styles from './ConversationalOnboarding.module.scss';

interface OnboardingNavigationProps {
  state: OnboardingV2State;
  onNavigateToStep: (step: OnboardingStep) => void;
  editingStep?: OnboardingStep | null;
  currentInteractiveType?: string;
}

const OnboardingNavigation: React.FC<OnboardingNavigationProps> = ({ state, onNavigateToStep, editingStep, currentInteractiveType }) => {
  const steps = getAllSteps(state);
  const getStepFromInteractive = (): OnboardingStep | null => {
    switch (currentInteractiveType) {
      case 'accountType':
        return 'accountType';
      case 'skills':
      case 'profiles':
        return 'skills';
      case 'workZones':
        return 'workZones';
      case 'summary':
        return 'summary';
      case 'commerceOffer':
      case 'commerceForm':
        return 'summary';
      case 'completeActions':
        return 'workZones';
      default:
        return null;
    }
  };
  const currentStep = getStepFromInteractive() ?? editingStep ?? getCurrentStep(state);
  const currentIndex = steps.findIndex((step) => step.id === currentStep);
  const lastActiveIndexRef = useRef<number>(0);

  useEffect(() => {
    if (currentIndex >= 0) {
      lastActiveIndexRef.current = currentIndex;
    }
  }, [currentIndex]);

  const activeIndex = currentIndex >= 0 ? currentIndex : lastActiveIndexRef.current;
  const activeStep = steps[activeIndex];
  const displayLabel = currentInteractiveType === 'completeActions'
    ? 'Finalizar'
    : activeStep?.label;

  return (
    <div className={styles.onboardingNavigation}>
      <h3 className={styles.navigationTitle}>Progreso</h3>
      <OnboardingProgress
        steps={steps}
        activeIndex={activeIndex}
        activeLabel={displayLabel}
        editingStep={editingStep}
        onNavigateToStep={onNavigateToStep}
      />
    </div>
  );
};

export default OnboardingNavigation;
